import AppLogoImage from "../../../../../assets/Images/Setting/ProductCube/ProductInfoLogo.png";

const ProductInfo = () => {
  return (
    <div className="flex-1 flex-col h-fit w-full  radius-10 back-white  align-left justify-start  pt-3 pb-2 pl-3 pr-3 g-2">
      <div className="w-full flex-col align-left justify-start g-1">
        <h3 className="t-16 color-grayColor poppins-medium weight-500">
          Product Info
        </h3>
        <hr color="#e5e5e5" className="w-full" />
      </div>
      <div className="flex-col flex-1 scroll-y align-left justify-start g-2 w-full">
        <div className="flex-col align-left justify-start g-1 w-full flex-1">
          <h4 className="t-14 weight-500 poppins color-grayColor">
            Brand identification
          </h4>
          <div className="flex-col align-end justify-start g-1">
            <img
              src={AppLogoImage}
              loading="lazy"
              alt=""
              style={{ width: "90%" }}
            />
            <div className="flex-row align-center justify-start w-fit g-05">
              <div
                className="radius-2"
                style={{ background: "#543ED2", width: "1rem", height: "1rem" }}
              ></div>
              <span className="t-12 poppins color-textColor">543ED2</span>
            </div>
          </div>
        </div>
        <div className="flex-col align-left justify-start g-1 w-full flex-1">
          <h4 className="t-14 weight-500 poppins color-grayColor">
            Product version
          </h4>
          <div className="flex-col align-left justify-start g-1">
            <p className="t-12 poppins color-textColor">
              You are using latest version of this product. Release date 02 oct,
              2025.
            </p>
            <p className="t-12 poppins color-textColor">Version 0.1.0</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductInfo;
